import { render, staticRenderFns } from "./BarChartTailNumbers.vue?vue&type=template&id=10552141&scoped=true&"
import script from "./BarChartTailNumbers.vue?vue&type=script&lang=js&"
export * from "./BarChartTailNumbers.vue?vue&type=script&lang=js&"
import style0 from "./BarChartTailNumbers.vue?vue&type=style&index=0&id=10552141&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10552141",
  null
  
)

export default component.exports